import { List } from 'immutable';
import { pathSubscription, subscription } from 'nike-re-framejs';

export const bringFriendsLoaded$ = pathSubscription(['clubNike', 'bringFriends']);
export const bringFriendsRules$ = pathSubscription(['clubNike', 'bringFriends', 'rules']);
export const bringFriendsOverviewArticle$ = pathSubscription(['clubNike', 'bringFriends', 'overview']);
export const bringFriendsActiveTab$ = subscription(db => db.getIn(['clubNike', 'bringFriends', 'activeTab']));

export const bringFriendsInvitationsFbShareLink$ = pathSubscription([
    'clubNike',
    'bringFriends',
    'invitations',
    'fbShareLink'
]);
export const bringFriendsInvitationsGpShareLink$ = pathSubscription([
    'clubNike',
    'bringFriends',
    'invitations',
    'gpShareLink'
]);
export const bringFriendsInvitationsTwShareLink$ = pathSubscription([
    'clubNike',
    'bringFriends',
    'invitations',
    'twShareLink'
]);
export const bringFriendsInvitationsErrors$ = pathSubscription(['clubNike', 'bringFriends', 'invitations', 'errors']);
export const bringFriendsInvitationsMessage$ = pathSubscription([
    'clubNike',
    'bringFriends',
    'invitations',
    'invitationMessage'
]);
export const bringFriendsInvitationsPatronNickname$ = pathSubscription([
    'clubNike',
    'bringFriends',
    'invitations',
    'patronNick'
]);

export const bringFriendsInvitationsError$ = errorId =>
    pathSubscription(['clubNike', 'bringFriends', 'invitations', 'errors', errorId], List());
export const bringFriendsOverviewBonus$ = pathSubscription([
    'clubNike',
    'bringFriends',
    'overview',
    'activePage',
    'bonusSum'
]);
export const bringFriendsOverviewLevel$ = pathSubscription([
    'clubNike',
    'bringFriends',
    'overview',
    'activePage',
    'bonusLevel'
]);
export const bringFriendsOverviewFriends$ = pathSubscription([
    'clubNike',
    'bringFriends',
    'overview',
    'activePage',
    'friends'
]);
export const bringFriendsOverviewPagesAvailable$ = pathSubscription([
    'clubNike',
    'bringFriends',
    'overview',
    'activePage',
    'pagesAvailable'
]);
export const bringFriendsOverviewActualPage$ = pathSubscription([
    'clubNike',
    'bringFriends',
    'overview',
    'activePage',
    'page'
]);
export const bringFriendsOverviewPagesCount$ = pathSubscription([
    'clubNike',
    'bringFriends',
    'overview',
    'activePage',
    'pagesCount'
]);
export const bringFriendsCurrency$ = pathSubscription(['config', 'actualCurrency']);
